export default __webpack_public_path__ + "static/media/skardu.e1d5b081.jpg";